import { useContext } from 'react';

import HistoryContext, { type HistoryState } from './Context';

const useHistory = (): HistoryState => useContext(HistoryContext);

export default useHistory;
